module.exports = __webpack_public_path__ + "media/images/cart/cart_bg-a539ec53608056c0eaa865b72e961d92.gif";